module.exports = __webpack_public_path__ + "img/peace_symbol.da95a562.gif";